import { apiClient } from '../../client'
import type { PaginatedResponse } from '../role.repository'

/** Row from GET /other-photos (flat SQL result) */
export interface OtherPhotoRow {
  id: number
  report_date: string
  images_name: string
  /** Backend-signed URL for images_name under capture/ */
  image_url?: string
  image_urls?: string
  visit_id: number
  photo_type_id: number
  store_id: number
  /** Store GPS as `"lat,lng"` (same as store G-Code) */
  g_code: string | null
  store: string
  depo?: string | null
  city: string
  region: string
  user_name: string
  photo_type: string
  category: string
  dynamic_bucket_url: string
  subcategory_name?: string
  brand_name?: string
}

export type OtherPhotoFilters = {
  start_date?: string
  end_date?: string
  store_id?: number
  city_ids?: string
  region_ids?: string
  client_ids?: string
  category_ids?: string
  photo_type_ids?: string
  subcategory_name?: string
  brand_name?: string
}


class OtherPhotosRepository {
  async getAll(
    page: number = 1,
    limit: number = 100,
    filters?: OtherPhotoFilters,
  ): Promise<PaginatedResponse<OtherPhotoRow>> {
    const params = new URLSearchParams()
    params.set('page', String(page))
    params.set('limit', String(limit))
    if (filters) {
      for (const [key, value] of Object.entries(filters)) {
        if (value === undefined || value === null || value === '') continue
        params.set(key, String(value))
      }
    }
    return apiClient.get<PaginatedResponse<OtherPhotoRow>>(`/other-photos?${params.toString()}`)
  }

  async exportToExcel(page: number = 1, limit: number = 10, filters?: OtherPhotoFilters): Promise<Blob> {
    const params = new URLSearchParams({ page: String(page), limit: String(limit) })
    if (filters) {
      for (const [key, value] of Object.entries(filters)) {
        if (value === undefined || value === null || value === '') continue
        params.set(key, String(value))
      }
    }
    return apiClient.getBlob(`/other-photos/export-other-photos-report?${params.toString()}`)
  }
}

export const otherPhotosRepository = new OtherPhotosRepository()
